@if ($banner(); as banner) {
  <div
    data-testid="global-banner"
    inline-banner
    [variant]="banner.variant"
    [type]="banner.type"
    [padding]="'small'"
    [flex-direction]="'row'"
    [flex-gap]="'small'"
  >
    <div [flex-fill]="'shrink'" [flex-align]="'center'" data-testid="global-banner-icon">
      <mat-icon>{{ banner.icon }}</mat-icon>
    </div>
    <div [flex-fill]="'grow'" [flex-align]="'center'" data-testid="global-banner-text">
      @if (banner.heading) {
        <div data-testid="global-banner-heading">
          {{ banner.heading }}
        </div>
      }
      <div data-testid="global-banner-message">
        {{ banner.message }}
      </div>
    </div>
    <div [flex-align]="'end'" [flex-fill]="'shrink'">
      <div [flex-align]="'center'" [flex-gap]="'x-small'" data-testid="global-banner-actions">
        @if (banner.action; as action) {
          <button mat-flat-button (click)="action?.handler()" data-testid="global-banner-action">
            {{ action?.label }}
          </button>
        }
        @if (banner.closable) {
          <mat-icon clickable (click)="closeBanner()" data-testid="global-banner-close">
            {{ closeIcon }}
          </mat-icon>
        }
      </div>
    </div>
  </div>
}
